import React from "react";

import ChatInputWrapper from "./ChatInputWrapper";

import type { Message } from "@/types/chat";
import type { ReactNode } from "react";

const ChatInputSection = ({
  input,
  isLoading = false,
  isStreaming = false,
  messages = [],
  onInputChange,
  onSend,
  onStop,
  disabled,
  placeholder,
  cap,
}: ChatInputSectionProps) => {
  return (
    <div className={`w-full`}>
      <div className={`flex-shrink-0 w-full`}>
        <ChatInputWrapper
          value={input || ""}
          onChange={onInputChange}
          onSend={onSend}
          onStop={onStop}
          disabled={isLoading || disabled}
          isStreaming={isStreaming}
          messages={messages}
          placeholder={placeholder}
          className="w-full"
          cap={cap}
        />
      </div>
    </div>
  );
};

type ChatInputSectionProps = {
  input: string;
  isLoading?: boolean;
  isStreaming?: boolean;
  messages?: Message[];
  onInputChange: (value: string) => void;
  onSend: () => void;
  onStop: () => void;
  disabled?: boolean;
  placeholder?: string;
  cap?: ReactNode;
};

export default ChatInputSection;
